import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {PrimaryButton} from "../../components/basic-componentes/buttons/primary-button";
import {PrimaryButtonInverted} from "../../components/basic-componentes/buttons/primary-button-inverted";
import {HorizontalSeparatorBox} from "../../components/search-mask/separators/horizontal-separator.box";
import {VerticalSeparatorBox} from "../../components/search-mask/separators/vertical-separator.box";
import {useServices} from "../../hooks/use-services.hook";
import {AirlineLogoMonocolorIcon} from "../../assets/svg/airline-logo-monocolor.icon";
import Div100vh from 'react-div-100vh';
import {CmsPageComponent} from "../../components/cms/cms-page.component";

const PageBox = styled(Div100vh)`
    display: flex;
    flex-direction: column;
    font-size: ${props => props.theme.fontSize.large};
    width: 100%;
`

const HeaderBox = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primaryContrast};
    font-size: ${props => props.theme.fontSize.xxLarge};
    font-weight: ${props => props.theme.fontWeight.bold};
    text-align: center;
    padding: ${props => `calc(env(safe-area-inset-top) + ${props.theme.spacing.large})`} ${props => `calc(env(safe-area-inset-right) + ${props.theme.spacing.large})`} ${props => props.theme.spacing.large} ${props => `calc(env(safe-area-inset-left) + ${props.theme.spacing.large})`};

    @media ${props => props.theme.mediaQuery.sAndBelow} {
      font-size: ${props => props.theme.fontSize.large};
    }
    
`

const LogoBox = styled.div`
    margin-bottom: ${props => props.theme.spacing.medium};
    cursor: pointer;
`

const ContentBox = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
`

const FooterBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.theme.fontSize.medium};
    background-color: ${props => props.theme.colors.light};
    width: 100%;
    padding: ${props => props.theme.spacing.large};
    padding: ${props => props.theme.spacing.large} ${props => `calc(env(safe-area-inset-right) + ${props.theme.spacing.large})`} ${props => `calc(env(safe-area-inset-bottom) + ${props.theme.spacing.large})`} ${props => `calc(env(safe-area-inset-left) + ${props.theme.spacing.large})`};

    @media ${props => props.theme.mediaQuery.sAndBelow} {
      flex-direction: column;
    }
`

const AgreeButton = styled(PrimaryButton)`
    @media ${props => props.theme.mediaQuery.sAndAbove} {
      width: 300px;
    }
`

const DoNotAgreeButton = styled(PrimaryButtonInverted)`
    @media ${props => props.theme.mediaQuery.sAndAbove} {
      width: 300px;
    }
`

export const SpecialPricesMarketPage: React.FC = observer(() => {
    const services = useServices();

    const continueWithSpecialPrices = () => {
       services.flightSearch.continueWithSpecialPrices();
    }

    const continueWithoutSpecialPrices = () => {
        services.flightSearch.continueWithoutSpecialPrices();
    }

    const onLogoClick = () => {
        services.window.goBack();
    }

    const marketName = services.flightSearch.searchController.getSpecialPriceMarket()?.marketName;

    if(!marketName) {
       return null;
    }

    return (
        <PageBox>
            <HeaderBox>
                <LogoBox onClick={onLogoClick}>
                    <AirlineLogoMonocolorIcon/>
                </LogoBox>

                <div>
                    {services.language.translate('TERRITORIAL CONTINUITY REGIME')}
                </div>

            </HeaderBox>

            <ContentBox>
                <CmsPageComponent pageKey={'pso'} urlBuilderParams={{market: marketName}}/>
            </ContentBox>

            <FooterBox>
                <AgreeButton fullWidth={services.mediaQuery.sAndBelow}
                               fontSize={"medium"}
                               onClick={continueWithSpecialPrices}>
                    {services.language.translate('I agree')}
                </AgreeButton>
                {services.mediaQuery.sAndBelow ? (<VerticalSeparatorBox/>) : (<HorizontalSeparatorBox/>)}
                <DoNotAgreeButton fullWidth={services.mediaQuery.sAndBelow}
                                       fontSize={"medium"}
                                       onClick={continueWithoutSpecialPrices}>
                    {services.language.translate('I do not agree')}
                </DoNotAgreeButton>
            </FooterBox>
        </PageBox>
    )
});
